module.exports = __webpack_public_path__ + "img/T4-C-rc_13.af8d0581.png";